import React from 'react';
import styled, { css } from 'styled-components';
import Check from 'utils/assetFiles/svgs/Check';

const Step = ({ number, text, active, complete, style }) => {
    const Container = styled.div`
        width: 204px;
        height: 70px;
        background: #ffffff;
        border-radius: 6px;
        display: flex;
        box-sizing: border-box;
        border-left: 8px solid #fff;
        ${active &&
        css`
            border-left-color: #6347ff;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
        `}
    `;

    const NumberContainer = styled.div`
        align-self: center;
        margin-left: 16px;
    `;

    const NumberWrapper = styled.div`
        width: 30px;
        height: 30px;
        border-radius: 50%;
        color: white;
        text-align: center;
        line-height: 30px;
        ${active
            ? css`
                  background-color: #6347ff;
              `
            : css`
                  background-color: #bdbdbd;
              `}
    `;

    const TextContainer = styled.div`
        align-self: center;
        margin-left: 19px;
    `;

    const TextWrapper = styled.div`
        line-height: 30px;
        font-size: 16px;
        ${active || complete
            ? css`
                  color: #6347ff;
              `
            : css`
                  color: #bdbdbd;
              `}
    `;

    return (
        <Container style={style}>
            <NumberContainer>{complete ? Check : <NumberWrapper>{number}</NumberWrapper>}</NumberContainer>
            <TextContainer>
                <TextWrapper>{text}</TextWrapper>
            </TextContainer>
        </Container>
    );
};

export default Step;
